import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Breadcrumb, BreadcrumbItem, Button, Card, Col, Container, Fa, Nav, NavItem, Row} from "mdbreact";
import {Link, NavLink} from "react-router-dom";
import validator from 'validator';
import axios from "axios";
import {LangValidation} from "./../../lang/fa/validation";

import {Alert} from "reactstrap";
import {setUser} from "./../../redux/actions/user";
import {API_URL} from "./../../config/Config";
import qs from "qs";

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemPills: '1',
            fields: {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                re_password: '',
                cell_phone: '',
                city_id: 1,
                username:'',
                reagent:''
            },
            errors: {},
            hasAlert:false,

        };

    }

     handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.firstname)) {
             formIsValid = false;
             errors["firstname"] = LangValidation.required;
         }else if (!validator.isLength(fields.firstname, {min: 3, max: undefined})) {
             formIsValid = false;
             errors["firstname"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.lastname)) {
             formIsValid = false;
             errors["lastname"] = LangValidation.required;
         }else if (!validator.isLength(fields.lastname, {min: 3, max: undefined})) {
             formIsValid = false;
             errors["lastname"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.email)) {
             formIsValid = false;
             errors["email"] = LangValidation.required;
         }else if (!validator.isEmail(fields.email)) {
             formIsValid = false;
             errors["email"] = LangValidation.email;
         }

         if (validator.isEmpty(fields.password)) {
             formIsValid = false;
             errors["password"] = LangValidation.required;
         }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
             formIsValid = false;
             errors["password"] = LangValidation.min;
         }

         if (validator.isEmpty(fields.re_password)) {
             formIsValid = false;
             errors["re_password"] = LangValidation.required;
         }else if (fields.re_password !== fields.password) {
             formIsValid = false;
             errors["re_password"] = LangValidation.same;
         }

         if (validator.isEmpty(fields.cell_phone)) {
             formIsValid = false;
             errors["cell_phone"] = LangValidation.required;
         }else if (!validator.isNumeric(fields.cell_phone)) {
             formIsValid = false;
             errors["cell_phone"] = LangValidation.numeric;
         }

         if (validator.isEmpty(fields.username)) {
             formIsValid = false;
             errors["username"] = LangValidation.required;
         }else if (!validator.isLength(fields.username, {min: 5, max: undefined})) {
             formIsValid = false;
             errors["username"] = LangValidation.min;
         }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

     handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

       switch (target.name) {
           case 'firstname':
               if (validator.isEmpty(fields.firstname)) {
                   errors["firstname"] = LangValidation.required;
               }else if (!validator.isLength(fields.firstname, {min: 3, max: undefined})) {
                   errors["firstname"] = LangValidation.min;
               }
               break;
           case 'lastname':
               if (validator.isEmpty(fields.lastname)) {
                   errors["lastname"] = LangValidation.required;
               }else if (!validator.isLength(fields.lastname, {min: 3, max: undefined})) {
                   errors["lastname"] = LangValidation.min;
               }
               break;
           case 'email':
               if (validator.isEmpty(fields.email)) {
                   errors["email"] = LangValidation.required;
               }else if (!validator.isEmail(fields.email)) {
                   errors["email"] = LangValidation.email;
               }
               break;
           case 'password':
               if (validator.isEmpty(fields.password)) {
                   errors["password"] = LangValidation.required;
               }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                   errors["password"] = LangValidation.min;
               }
               break;
           case 're_password':
               if (validator.isEmpty(fields.re_password)) {
                   errors["re_password"] = LangValidation.required;
               }else if (fields.re_password !== fields.password) {
                   errors["re_password"] = LangValidation.same;
               }
               break;
           case 'cell_phone':
               if (validator.isEmpty(fields.cell_phone)) {
                   errors["cell_phone"] = LangValidation.required;
               }else if (!validator.isNumeric(fields.cell_phone)) {
                   errors["cell_phone"] = LangValidation.numeric;
               }
               break;
           case 'username':
               if (validator.isEmpty(fields.username)) {
                   errors["username"] = LangValidation.required;
               }else if (!validator.isLength(fields.username, {min: 5, max: undefined})) {
                   errors["username"] = LangValidation.min;
               }
               break;
           default:

        }
        this.setState({
            fields,errors
        });

       }

    checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    handleRequest() {
        const {firstname, lastname, email, password, cell_phone, city_id, username, reagent} = this.state.fields;
        const data = {firstname, lastname, email, password, cell_phone, city_id, username, reagent};
        let errors = {};
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url:`${API_URL}register`,
        };
        axios(options)
            .then(
                this.checkStatus
            ).then(json => {
                this.props.setUser(json.data);
                this.props.history.push('/');
            })
            .catch(error => {
                const response = error.response;
                if (response === undefined) {
                  console.log(error);
                } else {
                    for (var key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            errors[key] = response.data[key];
                        }
                    }
                }
                this.setState({hasAlert:true, errors});
            });

    }

    handleRegister(event) {
        event.preventDefault();
       this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const {firstname, lastname, email, password, re_password, cell_phone,  username, reagent} = this.state.fields;
        const {errors} = this.state;


        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem active> ورود کاربر</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="container rtl" style={{marginTop: 100, marginBottom: 150}}>
                        <div className="row">
                            <div className="col-md-8 " style={{float: "none", margin: "0 auto"}}>
                                <Card style={{padding:20}}>

                                    <div className="card-header1 mb-2">
                                        <Nav pills color="secondary" className="nav-justified mt-2">
                                            <NavItem>
                                                <NavLink to="/login" className="btn btn-link">
                                                    ورود کاربر
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <Button to="/register" className="btn btn-default btn-block">
                                                    ثبت نام در سامانه
                                                </Button>
                                            </NavItem>
                                        </Nav>
                                        <hr/>
                                            <Row>
                                                <Col md="12">
                                                    {this.state.hasAlert?
                                                        <Alert color="danger">
                                                           خطایی در هنگام ثبت اطلاعات رخ داد.
                                                        </Alert>
                                                    :""}
                                                </Col>
                                            </Row>
                                        <form>
                                            <Row>
                                                <Col md="6" sm="12">
                                                    <div className="md-form input-group" error="true" >
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-user grey-text mt-3" style={{fontSize: 20}}/>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className={errors["firstname"]?"form-control is-invalid":"form-control"}
                                                            placeholder="نام"
                                                            autoComplete="off"
                                                            name="firstname"
                                                            value={firstname}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                        {errors["firstname"]?<div className="invalid-feedback" >{errors["firstname"]}</div>:""}
                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-user grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               placeholder="نام خانوادگی"
                                                               className={errors["lastname"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="lastname"
                                                               value={lastname}
                                                               onChange={this.handleChange.bind(this)}
                                                            />
                                                        {errors["lastname"]?<div className="invalid-feedback" >{errors["lastname"]}</div>:""}
                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-envelope grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="email"
                                                               placeholder="ایمیل"
                                                               className={errors["email"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="email"
                                                               value={email}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["email"]?<div className="invalid-feedback" >{errors["email"]}</div>:""}

                                                    </div>

                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-phone grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               placeholder="موبایل"
                                                               className={errors["cell_phone"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="cell_phone"
                                                               value={cell_phone}
                                                               onChange={this.handleChange.bind(this)}/>

                                                        {errors["cell_phone"]?<div className="invalid-feedback" >{errors["cell_phone"]}</div>:""}

                                                    </div>

                                                </Col>
                                                <Col md="6" sm="12">
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-user grey-text mt-3"
                                                           style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               placeholder="نام کاربری"
                                                               className={errors["username"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="username"
                                                               value={username}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["username"]?<div className="invalid-feedback" >{errors["username"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="password"
                                                               placeholder="رمز عبور"
                                                               className={errors["password"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="password"
                                                               value={password}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="password"
                                                               placeholder="تکرار رمز عبور"
                                                               className={errors["re_password"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="re_password"
                                                               value={re_password}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["re_password"]?<div className="invalid-feedback" >{errors["re_password"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                    <span className="input-group-addon p-2">
                                                        <i className="fa fa-random grey-text mt-3" style={{fontSize: 20}}/>
                                                    </span>
                                                        <input type="text"
                                                               className="form-control"
                                                               placeholder="کد معرف"
                                                               autoComplete="off"
                                                               name="reagent"
                                                               value={reagent}
                                                               onChange={this.handleChange.bind(this)}/>
                                                    </div>
                                                    <div className="text-center mt-5">
                                                        <Button color="default" block onClick={this.handleRegister.bind(this)} className="mb-4 mt-4">
                                                            ثبت <Fa icon="paper-plane-o white-text" className="ml-1"/>
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/containers/auth/Register.js